export const getOrganicDescription = (isOrganic: boolean | null): string => {
  if (isOrganic === null) return 'All Types';
  return isOrganic ? 'Organic' : 'Conventional';
};
